export default "__VITE_ASSET__e1446468__"